import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { ToastrService } from 'ngx-toastr'; 
@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent implements OnInit {
  vouchers: any[] = [];
  managerid : string = "";
  vouchercode : string = "";
  constructor(private http: HttpClient, public dialog: MatDialog,public service: SharkifyAiSerivceService , public toast : ToastrService) {}

  ngOnInit(): void {
    this.managerid  = this.getSafeValue(localStorage.getItem("ManagerUserId"))
    this.service.VouchersList(this.managerid).subscribe( data => {
       if(data.Code == 200){
        this.vouchers = data.Vouchers;
       }
    } )
  }
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  getVoucherStatus(voucher: any): string {
    return voucher.usedOn ? 'Voucher is Used' : 'New';
  }

  deleteVoucher(id: number): void {
   this.service.DeleteVoucher(id+"").subscribe(data => {
    if(data.Code == 200){
      this.toast.success("Voucher deleted successfully");
       this.vouchers = this.vouchers.filter(voucher => voucher.VoucherId !== id);
    }else {
      this.toast.error("Something went wrong");
    }
   })
  //  this.ngOnInit();
  }
  opendialog(voucherid : number , vouchercode : string): void {
    const data = {
      managerid : this.managerid,
      voucherid ,
      vouchercode
    }
    const dialogRef = this.dialog.open(VoucherDialogComponent, {
      width: '400px',
      data: data 
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }
}

@Component({
  selector: 'app-voucher-dialog',
  templateUrl: './voucher-dialog.component.html',
  styleUrls: ['./voucher-dialog.component.css']
})
export class VoucherDialogComponent {
  voucherCode: string | undefined;
  voucherValue: number = 0;
  context : string = "";
  constructor(
    public dialogRef: MatDialogRef<VoucherDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public service: SharkifyAiSerivceService,
    public toast : ToastrService
  ) {
    if(this.data.vouchercode == 'none'){
    this.voucherCode = this.generateVoucherCode();
    this.context = "CREATE"
    }else{
      this.voucherCode = this.data.vouchercode;
      this.context = "UPDATE"
    }
  }

  generateVoucherCode(): string {
    const generateRandomString = (length: number): string => {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    };
  
    return generateRandomString(4) + '-' + generateRandomString(4) + '-' + generateRandomString(4);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createVoucher(): void {
    if (this.voucherValue && this.voucherCode) {
      if(this.context == "CREATE"){
      this.service.CreateNewVoucher(this.voucherCode+"",this.voucherValue+"",this.data.managerid).subscribe(data => {
        if(data.Code == 200){
          this.toast.success( this.voucherCode + "with value of "+this.voucherValue+ " voucher added sucessefully");
          this.onNoClick();
        }
      });
    }else{
      this.service.UpdatedVoucher(this.data.voucherid,this.voucherValue+"").subscribe(data => {
        if(data.Code == 200){
          this.toast.success( this.voucherCode + "with value of "+this.voucherValue+ " voucher updated sucessefully");
          this.onNoClick();
        }
      });
    }
    }
  }
}